import React from 'react';

type Props = {
  children: React.ReactNode;
};

const InputComponent = ({ children }: Props) => {
  return <>{children}</>;
};

export default InputComponent;
